import { AppBar, Button, Container, Divider, Grid, Toolbar, Typography,Link, TextField, Box, Paper } from "@mui/material";
import { useMediaQuery } from 'react-responsive'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import logo from './RestoFinalLogo.png';
import { styled } from '@mui/material/styles';
import { purple, teal,blueGrey } from "@mui/material/colors";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import validator from 'validator';
import React, {Fragment, useState} from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import StartIcon from '@mui/icons-material/Start';
import restologo from './restologo.png';





const LoginPage = props => {

    const [emailState, setEmailState] = React.useState("");
    const [validateState, setValidateState] = React.useState(true);
    const [fakeState, setFakeState] = React.useState("1");

    const emailSetter = (event) => {
        setEmailState(event.target.value);
        setFakeState("1")
      }

    function Copyright(props) {
        return (
          <Typography sx={{mb:4}} variant="body2" color="#212121" align="center" {...props}>
            {'Copyright © '}
            <Link color="#424242" href="https://ndfmbusinessworld.com/">
              NDFM Business World Private Limited
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        );
      }

    const homeButtonHandler = () => {
        props.loginPageStateChange({loginPageState : false})
        props.homePageStateChange({homePageState:true})
   
    }

    const fieldColorHandler = () => {
        setValidateState(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(validator.isEmail(emailState)){
            setFakeState("2");
       
        }
        else{
            setValidateState(false);
        }
    }

    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(teal[900]),
        backgroundColor: blueGrey[800],
        '&:hover': {
          backgroundColor: blueGrey[700],
        },
      }));

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

    let passPropertiesToChild = {
       
    }


  return(

    <ThemeProvider
    theme={createTheme({
      components: {
        MuiListItemButton: {
          defaultProps: {
            disableTouchRipple: true,
          },
        },
      },
      palette: {
        mode: 'light',
        primary: { main: '#eceff1' },
        background: { paper: '#eceff1' },
        button : "#b0bec5"
      },
    })}
  >

    {isDesktopOrLaptop && (
       <React.Fragment>
       <AppBar elevation={0} >
         <Toolbar disableGutters>
           
         <Grid sx={{pt:1, pb:0,mx:4,my:2}}container spacing={0}  alignItems="center" justifyContent="flex-start">

         <Grid item  xs={12} sm={4.5} >
              <img  src={logo} alt="" style={{ width:"55%"}}/>
          </Grid>

          <Grid item  xs={12} sm={3} >
              <img  src={restologo} alt="" style={{ width:"38%"}}/>
          </Grid>

             <Grid item xs={12} sm={4.5} sx={{mb:1}}>
             <Grid container spacing={0}  alignItems="center" justifyContent="flex-end">
             <Grid item xs="auto">
             <ColorButton startIcon={<HomeIcon />} variant="contained"  onClick={homeButtonHandler}>Home</ColorButton>
             </Grid>
             </Grid>
             </Grid>    

       </Grid>
         </Toolbar>
       
     </AppBar>


    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 20 }}>
       <Grid container spacing={1.5}>

       <Grid item xs={4}></Grid>
            <Grid item xs={4}>
            <Paper elevation={0}>
            <Grid container spacing={1.5} sx={{p:3}}>

            <Grid item xs={12}>
                <Typography color="#004d40"  align="center">
                    <AccountCircleIcon fontSize="large"/>
                    </Typography>

                    <Typography color="#004d40"  align="center">
                        Create Acoount / Sign in
                    </Typography>
                </Grid>
                
            <Grid item xs={12} >
                {validateState && (
              <TextField
              color="success"
                value={emailState}
                onChange={emailSetter}
                size="small"
                required
                fullWidth
                id="emailAddress"
                label="Email Address"
                name="emailAddress"
                variant="standard"
              />
                )}

            {! validateState && (
              <TextField
                error
                value={emailState}
                onChange={emailSetter}
                size="small"
                required
                fullWidth
                id="emailAddress"
                label="Email Address"
                name="emailAddress"
                variant="standard"
                helperText="Enter valid email address."
                onClick={fieldColorHandler}
              />
                )}
              </Grid>


              {fakeState === "2" && (
                <Grid item xs={12}>
                <React.Fragment>
                    <Typography sx={{mx:2,mt:3}} color="#b71c1c" align="center">Account not found with email address : {emailState}</Typography>
                    <Typography sx={{mx:2,mt:3}} color="#b71c1c" align="center">We are not onboarding new customers for few days.</Typography>
                    <Typography sx={{mx:2}} color="#b71c1c" align="center">Please fill the online contact form to get notified when the onboarding process resumes.</Typography>
                    <Link align="center" color="#424242" href="https://ndfmbusinessworld.com/online-contact-form"><Typography align="center" sx={{mx:2,mt:2}} > Online Contact Form</Typography> </Link>
                    </React.Fragment>
                    </Grid>
              )}
           
              <Grid item xs={12} >
            <ColorButton type="submit" fullWidth variant="contained" sx={{  mb: 2,mt:2 }} onClick={handleSubmit}> Next</ColorButton>
            </Grid>


              </Grid>
              </Paper>
            </Grid>
            <Grid item xs={4}></Grid>
            </Grid>
            </Box>
            </React.Fragment>
         
    )}




{isTabletOrMobile && (
       <React.Fragment>
       <AppBar elevation={0} >
         <Toolbar disableGutters>
           
         <Grid sx={{pt:1, pb:0,mx:4,my:2}}container spacing={0}  alignItems="center" justifyContent="flex-start">

         <Grid item  xs={12} sm={4.5} >
              <img  src={logo} alt="" style={{ width:"55%"}}/>
          </Grid>

          <Grid item  xs={12} sm={3} >
              <img  src={restologo} alt="" style={{ width:"38%"}}/>
          </Grid>

             <Grid item xs={12} sm={4.5} sx={{mb:1}}>
             <Grid container spacing={0}  alignItems="center" justifyContent="flex-start">
             <Grid item xs="auto">
             <ColorButton startIcon={<HomeIcon />} variant="contained"  onClick={homeButtonHandler}>Home</ColorButton>
             </Grid>
             </Grid>
             </Grid>    

       </Grid>
         </Toolbar>
       
     </AppBar>


    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 36 }}>
       <Grid container spacing={1}>

     
            <Grid sx={{ml:1,mr:1}} item xs={12}>
            <Paper elevation={0}>
            <Grid container spacing={1.5} sx={{p:1}}>

            <Grid item xs={12}>
                <Typography color="#004d40"  align="center">
                    <AccountCircleIcon fontSize="large"/>
                    </Typography>

                    <Typography color="#004d40"  align="center">
                        Create Acoount / Sign in
                    </Typography>
                </Grid>
                
            <Grid item xs={12} >
                {validateState && (
              <TextField
              color="success"
                value={emailState}
                onChange={emailSetter}
                size="small"
                required
                fullWidth
                id="emailAddress"
                label="Email Address"
                name="emailAddress"
                variant="standard"
              />
                )}

            {! validateState && (
              <TextField
                error
                value={emailState}
                onChange={emailSetter}
                size="small"
                required
                fullWidth
                id="emailAddress"
                label="Email Address"
                name="emailAddress"
                variant="standard"
                helperText="Enter valid email address."
                onClick={fieldColorHandler}
              />
                )}
              </Grid>


              {fakeState === "2" && (
                <Grid item xs={12}>
                <React.Fragment>
                    <Typography sx={{mx:2,mt:3}} color="#b71c1c" align="center">Account not found with email address : {emailState}</Typography>
                    <Typography sx={{mx:2,mt:3}} color="#b71c1c" align="center">We are not onboarding new customers for few days.</Typography>
                    <Typography sx={{mx:2}} color="#b71c1c" align="center">Please fill the online contact form to get notified when the onboarding process resumes.</Typography>
                    <Link align="center" color="#424242" href="https://ndfmbusinessworld.com/online-contact-form"><Typography align="center" sx={{mx:2,mt:2,mb:1}} > Online Contact Form</Typography> </Link>
                    </React.Fragment>
                    </Grid>
              )}
           
              <Grid item xs={12} >
            <ColorButton type="submit" fullWidth variant="contained" sx={{  mb: 2,mt:2 }} onClick={handleSubmit}> Next</ColorButton>
            </Grid>


              </Grid>
              </Paper>
            </Grid>
           
            </Grid>
            </Box>
            </React.Fragment>
         
    )}

  
    <Divider sx={{m:4,mx:10,my:4,mt:30}}/>
    <Copyright />
    </ThemeProvider>
   
     
     
    
  );
}   

export default LoginPage;